import { component } from 'picoapp';
import { merge } from 'lodash-es';
const str2json = require("../../../utils/str2json");
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/autoplay/autoplay.min.css';

class SwiperSlider extends HTMLElement {
  constructor() {
    super();
  }


  connectedCallback() {
    this.defaults = {
      modules: [Navigation, Pagination, Autoplay],
      observer: true,
      createElements: true,
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 48
        }
      }
    }
    this.options = merge(this.defaults, str2json(this.dataset.options));
    const swiper = new Swiper(this, this.options);
  }
}

export default component((node, ctx) => {
  if (!customElements.get('swiper-slider')) {
    customElements.define('swiper-slider', SwiperSlider)
  }
})
